// No imports: the Studio page bundles this file too, so the browser and the server check addresses the same way.

// A plain address only: no display name, comments, quoting, lists or whitespace (`Pat <pat@x.com>`, `a@x.com, b@y.com`).
export const EMAIL_RE = /^[^\s@<>"(),;:]+@[^\s@<>"(),;:]+\.[^\s@<>"(),;:]+$/;

export const DEFAULT_STAFF_DOMAINS = ["bagcarriers.com"];

// STUDIO_STAFF_DOMAINS: a comma-separated list. Unset or blank means bagcarriers.com only.
export function parseStaffDomains(v: string | undefined): string[] {
  const list = (v ?? "").split(",").map((d) => d.trim().toLowerCase()).filter(Boolean);
  return list.length > 0 ? list : DEFAULT_STAFF_DOMAINS;
}

// Exact domain match, any letter case: a subdomain or a look-alike suffix does not count.
export function staffDomainAllowed(email: string, domains: string[]): boolean {
  const at = email.lastIndexOf("@");
  return at > 0 && domains.includes(email.slice(at + 1).toLowerCase());
}

export function staffDomainMessage(domains: string[]): string {
  return `Use your ${domains.join(" or ")} email.`;
}
